import React, { useRef, useEffect, Fragment, useState } from 'react';
import IntlMessages from 'util/IntlMessages';
import Loading from 'util/loading';
import axios from 'axios';
import {
  Box,
  Select,
  Card,
  CardContent,
  IconButton,
  Alert,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Button,
  Typography,
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import { red, indigo, green, grey, blue } from '@mui/material/colors';

import { Check, Close } from '@mui/icons-material';
import { API } from 'aws-amplify';

const styles = {
  horizontalBox: {
    display: 'flex',
    flexDirection: 'row',
  },
  card: {
    border: 1,
    marginTop: 1,
  },
  cardContents: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  select: {
    minWidth: '320px',
  },
};

// interceptors colocados para o axios retornar o tempo de resposta
axios.interceptors.request.use((x) => {
  // to avoid overwriting if another interceptor
  // already defined the same object (meta)
  x.meta = x.meta || {};
  x.meta.requestStartedAt = new Date().getTime();
  return x;
});

axios.interceptors.response.use(
  (x) => {
    x.responseTime = new Date().getTime() - x.config.meta.requestStartedAt;
    console.log(
      `Execution time for: ${x.config.url} - ${
        new Date().getTime() - x.config.meta.requestStartedAt
      } ms`
    );
    return x;
  },
  // Handle 4xx & 5xx responses
  (x) => {
    console.error(
      `Execution time for: ${x.config.url} - ${
        new Date().getTime() - x.config.meta.requestStartedAt
      } ms`
    );
    throw x;
  }
);

const Item = (params) => {
  const [loading, setLoading] = useState(false);
  const mounted = useRef(null);
  const [operators, setOperators] = useState([]);
  const [urns, setUrns] = useState([]);

  const [currentOperatorId, setCurrentOperatorId] = useState('');
  const [currentUrn, setCurrentUrn] = useState('');

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const initAuth = {
    access: false,
    request: '',
    response: '',
    responseTime: 0,
  };
  const [authN, setAuthN] = useState(initAuth);
  const [authZ, setAuthZ] = useState(initAuth);

  const [alert, setAlert] = useState({
    severity: 'info',
    message: '',
    open: false,
  });

  useEffect(() => {
    mounted.current = true;

    listOperators();
    listUrns();

    return function cleanup() {
      mounted.current = false;
    };
  }, []);

  async function listOperators() {
    try {
      setLoading(true);
      const apiName = 'lambdaApi';
      const path = '/listOperators';
      const response = await API.get(apiName, path);
      console.log(response);
      setOperators(response.sort(compareOperators));
    } catch (error) {
      console.log(error);
      setAlert({
        message: error.toString(),
        severity: 'error',
        open: true,
      });
    } finally {
      setLoading(false);
    }
  }

  async function listUrns() {
    try {
      setLoading(true);
      const apiName = 'lambdaApi';
      const path = '/listUrns';
      const response = await API.get(apiName, path);
      console.log(response);
      setUrns(response.sort(compareUrns));
    } catch (error) {
      console.log(error);
      setAlert({
        message: error.toString(),
        severity: 'error',
        open: true,
      });
    } finally {
      setLoading(false);
    }
  }

  function plain(str) {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  const compareOperators = function (a, b) {
    if (plain(a.name) > plain(b.name)) return 1;
    if (plain(a.name) < plain(b.name)) return -1;
    return 0;
  };

  const compareUrns = function (a, b) {
    if (plain(a.urn) > plain(b.urn)) return 1;
    if (plain(a.urn) < plain(b.urn)) return -1;
    return 0;
  };

  function handleCloseAlert() {
    setAlert({
      message: '',
      severity: 'info',
      open: false,
    });
  }

  function handleChangeUrn(e) {
    setCurrentUrn(e.target.value);
  }

  function handleChangeOperator(e) {
    console.log(e.target.value);
    setCurrentOperatorId(e.target.value);
  }

  function handleChangePassword(e) {
    setPassword(e.target.value);
  }

  function handleChangeUsername(e) {
    setUsername(e.target.value);
  }

  function prettyJSON(aJson) {
    try {
      return JSON.stringify(JSON.parse(aJson), null, 2);
    } catch (error) {
      console.log(error);
      return aJson;
    }
  }

  async function login() {
    try {
      setLoading(true);
      const url =
        'https://9097yffrd7.execute-api.us-east-1.amazonaws.com/staging/';

      setAuthN(initAuth);
      setAuthZ(initAuth);

      const authNParams = {
        username: username,
        password: password,
        idp: currentOperatorId,
        includeResponse: true,
      };
      const result = await axios.get(url + 'authentication', {
        params: authNParams,
      });
      console.log(result);
      const options = JSON.parse(result.data.response.request.options);
      setAuthN({
        access: Boolean(result.data.access),
        request:
          result.data.response.request.protocol +
          '//' +
          options.host +
          options.path,
        response: prettyJSON(result.data.response.contents),
        responseTime: result.responseTime,
      });

      // se autenticou, tenta autorizar
      if (Boolean(result.data.access)) {
        const authZParams = {
          resource_id: currentUrn,
          subscriber_id: result.data.subscriber_id,
          includeResponse: true,
          passThrough: true,
        };
        const result2 = await axios.get(url + 'authorization', {
          params: authZParams,
        });
        const options2 = JSON.parse(result2.data.response.request.options);
        console.log(result2);
        setAuthZ({
          access: Boolean(result2.data.access),
          request:
            result2.data.response.request.protocol +
            '//' +
            options2.host +
            options2.path,
          response: prettyJSON(result2.data.response.contents),
          responseTime: result2.responseTime,
        });
      }
    } catch (error) {
      console.log(error);
      setAlert({
        message: error.toString(),
        severity: 'error',
        open: true,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Fragment>
      <Loading loading={Boolean(loading)} />
      <Snackbar
        open={alert.open}
        autoHideDuration={4000}
        onClose={handleCloseAlert}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Alert severity={alert.severity}>{alert.message}</Alert>
      </Snackbar>

      <Typography variant="h6" align="left" className="ml-3">
        <IntlMessages id="neo.gateway.accessTest" />
      </Typography>

      <Card sx={styles.card}>
        <CardContent sx={styles.cardContents}>
          <FormControl required className="w-100 mb-2" variant="standard">
            <InputLabel>
              <IntlMessages id="neo.operators.single" />
            </InputLabel>

            <Select
              name="currentOperator"
              value={currentOperatorId}
              onChange={(e) => handleChangeOperator(e)}
              variant="standard"
              sx={styles.select}
            >
              {operators.map((op, idx) => (
                <MenuItem key={idx} value={op.id}>
                  {op.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl required variant="standard">
            <InputLabel>
              <IntlMessages id="neo.gateway.product" />
            </InputLabel>
            <Select
              name="currentUrn"
              value={currentUrn}
              onChange={(e) => handleChangeUrn(e)}
              variant="standard"
              sx={styles.select}
            >
              {urns.map((item, idx) => (
                <MenuItem key={idx} value={item.urn}>
                  {item.urn}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl variant="standard">
            <TextField
              id="username"
              label="Username"
              value={username}
              onChange={handleChangeUsername}
              variant="standard"
            />
          </FormControl>
          <FormControl variant="standard">
            <TextField
              id="password"
              label="Password"
              value={password}
              onChange={handleChangePassword}
              variant="standard"
            />
          </FormControl>

          <Button
            variant="contained"
            color="primary"
            disabled={
              currentUrn.length === 0 ||
              username.length === 0 ||
              password.length === 0
            }
            onClick={() => login()}
          >
            Enviar
          </Button>
        </CardContent>
      </Card>

      <Card sx={styles.card}>
        <CardContent>
          <InputLabel>AuthN</InputLabel>
          {authN.access && (
            <IconButton
              edge="end"
              sx={{
                color: 'white',
                backgroundColor: green[500],
                marginLeft: 'auto',
                width: '32px',
                height: '32px',
                marginRight: 4,
              }}
            >
              <Check />
            </IconButton>
          )}
          {!authN.access && (
            <IconButton
              edge="end"
              sx={{
                color: 'white',
                width: '32px',
                backgroundColor: red[500],
                marginLeft: 'auto',
                height: '32px',
                marginRight: 4,
              }}
            >
              <Close />
            </IconButton>
          )}
          <pre>
            <code>{authN.request}</code>
          </pre>
          <pre>
            <code>{authN.response}</code>
          </pre>
          <InputLabel>{authN.responseTime} ms</InputLabel>
        </CardContent>
      </Card>

      <Card sx={styles.card}>
        <CardContent>
          <div className="row">
            <InputLabel>AuthZ</InputLabel>
            {authZ.access && (
              <IconButton
                edge="end"
                sx={{
                  color: 'white',
                  backgroundColor: green[500],
                  marginLeft: 'auto',
                  width: '32px',
                  height: '32px',
                  marginRight: 4,
                }}
              >
                <Check />
              </IconButton>
            )}
            {!authZ.access && (
              <IconButton
                edge="end"
                sx={{
                  color: 'white',
                  width: '32px',
                  backgroundColor: red[500],
                  marginLeft: 'auto',
                  height: '32px',
                  marginRight: 4,
                }}
              >
                <Close />
              </IconButton>
            )}
          </div>
          <pre>{authZ.request}</pre>
          <pre>
            <code>{authZ.response}</code>
          </pre>
          <InputLabel>{authZ.responseTime} ms</InputLabel>
        </CardContent>
      </Card>
    </Fragment>
  );
};

export default Item;
